import { yupResolver } from '@hookform/resolvers/yup'
import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    TextField,
} from '@mui/material'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useCFDContext } from './context/useCFDContext'
import * as yup from 'yup'
import useCustomFetch from './hook/useCustomFetch'
import { useHistory } from 'react-router-dom'
import { CFDROUTE } from './CFDLayout'
import cfdToast from 'views/CustomerFacingDisplay/utils/cfdToast'
interface SelectorForm {
    url: string
}

export const CFDHwAgentSettingPage = () => {
    const history = useHistory()
    const { setHWAgentURL, hwAgentUrl } = useCFDContext()

    const caller = useCustomFetch()
    const validateSchema: yup.SchemaOf<SelectorForm> = yup
        .object()
        .shape({
            url: yup.string().required(),
        })
        .defined()

    const form = useForm<SelectorForm>({
        defaultValues: {
            url: hwAgentUrl,
        },
        resolver: yupResolver(validateSchema),
    })
    const { register, handleSubmit } = form

    const saveUrl = useCallback(
        (form: SelectorForm) => {
            setHWAgentURL(form.url)
            history.push(CFDROUTE.HOME)
            cfdToast.success('Updated')
        },
        [history, setHWAgentURL],
    )
    const handleCheckHWAgent = useCallback(async () => {
        await caller(`${form.getValues('url')}/system`, {
            successMessage: 'HW Agent is able to connect.',
            errorMessage: 'HW Agent is unable to connect.',
        })
    }, [caller, form])

    const onGetCert = useCallback(async () => {
        await caller(`${form.getValues('url')}/system/download-root-ca`, {
            successMessage: 'Download Root CA successful',
            errorMessage: 'Unable to download Root CA',
        })
    }, [caller, form])

    return (
        <Container>
            <Card
                sx={{
                    margin: 'auto',
                    width: { md: '60%', sm: '100%' },
                    padding: '10px',
                    marginTop: '20%',
                }}
            >
                <CardContent>
                    <h2>Connect to Hardware agent</h2>
                    <form onSubmit={handleSubmit((e) => saveUrl(e))}>
                        <Card variant={'outlined'}>
                            <Box p={{ xs: 2, md: 3, lg: 5 }}>
                                <Grid
                                    container
                                    direction={'column'}
                                    spacing={2}
                                >
                                    <Grid item xs={12}>
                                        <TextField
                                            size="medium"
                                            {...register('url')}
                                            label="Hardware Agent URL"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            color="primary"
                                            onClick={onGetCert}
                                        >
                                            Install Cert
                                        </Button>
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            onClick={handleCheckHWAgent}
                                            color="primary"
                                        >
                                            Check connection
                                        </Button>
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            color="primary"
                                        >
                                            Connect to HW
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    </form>
                </CardContent>
            </Card>
        </Container>
    )
}
